module.exports = __webpack_public_path__ + "img/login-2.665cce85.png";